import { isBedbankOffer } from 'lib/offer/offerTypes'

/**
 * Builds the property identity for the "Select dates" functionality when a user clicks
 * on a property to select dates for it. This is used across various search pages.
 *
 * @param offer - The offer that was clicked
 * @returns An object containing propertyId, propertyName, and the property search item
 */
export function buildSelectDatesSearchParams(
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary,
): {
  propertyId: string
  propertyName: string
  propertySearchItem: App.SearchItem
} {
  const isBedbank = isBedbankOffer(offer)
  const propertyId = offer.property.id
  const propertyName = isBedbank ? offer.name : offer.property.name

  // Add appropriate prefix to property ID if not already present
  const prefix = isBedbank ? 'bedbank' : 'le'
  const propertyIdWithPrefix = propertyId.includes(':') ? propertyId : `${prefix}:${propertyId}`

  const propertySearchItem: App.SearchItem = {
    searchType: 'property',
    value: propertyIdWithPrefix,
    format: {
      mainText: propertyName,
    },
  }

  return {
    propertyId: propertyIdWithPrefix,
    propertyName,
    propertySearchItem,
  }
}
